import { render } from "./ChartCriteriaSkeleton.vue?vue&type=template&id=39166c12"
import script from "./ChartCriteriaSkeleton.vue?vue&type=script&lang=js"
export * from "./ChartCriteriaSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__